import { render, staticRenderFns } from "./sapCustomer.vue?vue&type=template&id=0d56c332"
import script from "./sapCustomer.vue?vue&type=script&lang=js"
export * from "./sapCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports